import React, { useEffect, useState } from 'react';
import LeftBar from '../../Pages/Layout/LeftBar';
import TopBar from '../../Pages/Layout/TopBar';
import Footer from '../../Pages/Layout/Footer';
import { DashboardGetbyIdhooks } from '../../Helper/HomeHelper';

const HomeComponent = () => {
  const [rolename, setRoleName] = useState('');
  const [fullName, setFullName] = useState('');
  const [homedata, setHomeData] = useState({});

  useEffect(() => {
    const id = localStorage.getItem("userId");
    const role = localStorage.getItem("roleName") || 'Admin';
    const name = localStorage.getItem("name") || 'User';

    setRoleName(role);
    setFullName(name);

    getData(id);
  }, []);

  async function getData(id) {
    const data = await DashboardGetbyIdhooks(id);
    if (data !== undefined) {
      setHomeData(data);
    }
  }

  const summaryData = [
    { icon: 'lnr-screen', label: 'Total Screens', value: homedata.totalScreens || 0, color: 'primary' },
    { icon: 'lnr-layers', label: 'Layouts', value: homedata.totalLayouts || 0, color: 'secondary' },
    { icon: 'lnr-picture', label: 'Media Files', value: homedata.totalMedia || 0, color: 'success' },
    { icon: 'lnr-warning', label: 'Offline Screens', value: homedata.totalOfflineScreen || 0, color: 'danger' },
    { icon: 'lnr-sync', label: 'Uptime (7 Days)', value: 'N/A', color: 'info' },
    { icon: 'lnr-calendar-full', label: "This Week's Schedules", value: homedata.totalSchedules || 0, color: 'warning' }
  ];

  return (
    <>
      <TopBar />
      <LeftBar />

      <div className="container-fluid content-top-gap">

        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb my-breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
          </ol>
        </nav>

        

        {/* Summary Cards */}
        <div className="row">
          {summaryData.map((card, idx) => (
            <div className="col-sm-6 col-md-4 col-lg-2 mb-4" key={idx}>
              <div className={`card card_border border-${card.color}-top p-3 h-100`}>
                <div className="d-flex flex-column align-items-center text-center">
                  <i className={`lnr ${card.icon} mb-2`} style={{ fontSize: '24px' }}></i>
                  <h4 className={`text-${card.color} mb-1`}>{card.value}</h4>
                  <p className="stat-text mb-0">{card.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Screen Status Table */}
        <div className="card mb-4">
          <div className="card-header">Display Status</div>
          <div className="card-body table-responsive">
            <table className="table table-bordered table-striped mb-0">
              <thead className="thead-light">
                <tr>
                  <th>Screen Name</th>
                  <th>Status</th>
                  <th>Last Sync</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {homedata.screenViews?.map((screen, idx) => (
                  <tr key={idx}>
                    <td>{screen.screenName}</td>
                    <td>{screen.statusDevice === 'Online' ? '✅ Online' : '❌ Offline'}</td>
                    <td>{screen.updatedDate ? new Date(screen.updatedDate).toLocaleString() : 'N/A'}</td>
                    <td>{screen.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Media Summary Table */}
        <div className="card mb-4">
          <div className="card-header">Media Summary</div>
          <div className="card-body table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="thead-light">
                <tr><th>Type</th><th>Count</th><th>Most Used</th></tr>
              </thead>
              <tbody>
                {homedata.mediaSummaries?.map((media, idx) => (
                  <tr key={idx}>
                    <td>{media.type}</td>
                    <td>{media.count}</td>
                    <td>{media.mostUsed || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Schedules Table */}
        {homedata.schedules?.length > 0 && (
          <div className="card mb-4">
            <div className="card-header">This Week's Schedules</div>
            <div className="card-body table-responsive">
              <table className="table table-bordered mb-0">
                <thead className="thead-light">
                  <tr>
                    <th>Event</th>
                    <th>Campaign</th>
                    <th>Screen Group</th>
                    <th>Start</th>
                    <th>End</th>
                  </tr>
                </thead>
                <tbody>
                  {homedata.schedules.map((schedule, idx) => (
                    <tr key={idx}>
                      <td>{schedule.eventName}</td>
                      <td>{schedule.campaignName || '-'}</td>
                      <td>{schedule.screenGroupName || '-'}</td>
                      <td>{new Date(schedule.startTime).toLocaleString()}</td>
                      <td>{new Date(schedule.endTime).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Alerts (Static or dynamic based on future requirements) */}
        {/* <div className="card mb-5">
          <div className="card-header bg-danger text-white">Alerts</div>
          <div className="card-body">
            <ul className="list-unstyled mb-0">
              <li>❗ Screen "Shop LED" hasn't synced for 14 hours</li>
              <li>⚠️ Media "promo_video.mp4" failed on 2 screens</li>
              <li>⏳ Layout "WelcomeLoop" is 20 days old</li>
            </ul>
          </div>
        </div> */}
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default HomeComponent;
